import { useCallback, useState } from "react";
import { LayoutRectangle } from "react-native";

export const useLayout = (
  initalLayout: LayoutRectangle = { x: 0, y: 0, width: 0, height: 0 }
) => {
  const [layout, setLayout] = useState(initalLayout);
  const onLayout = useCallback(
    ({ nativeEvent }: { nativeEvent: { layout: LayoutRectangle } }) => {
      setLayout(nativeEvent.layout);
    },
    []
  );
  return [layout, onLayout] as [
    LayoutRectangle,
    ({ nativeEvent }: { nativeEvent: { layout: LayoutRectangle } }) => void,
  ];
};
